/**
 * 全角文字かどうかチェック
 */
const checkFullPitchCharacter = (string: any) => {
  // eslint-disable-next-line no-control-regex
  return string.match(/^[^\x01-\x7E\xA1-\xDF]+$/);
};

/**
 * Check input is valid
 *
 * @returns {boolean}
 */
export const checkLengthInput = (string: string, length: number) => {
  let isValid = true;
  const len = Math.floor(length / 2);
  if (checkFullPitchCharacter(string)) {
    if (string.length > len) {
      isValid = false;
    }
  } else if (string.length > length) {
    isValid = false;
  }
  return {
    isValid,
    error: length + "文字以内で入力してください"
  };
};

export const checkNullInput = (string: string) => {
  let isValid = true;
  if (!string) {
    isValid = false;
  }
  return {
    isValid,
    error: "検索条件を入力してください。"
  };
};
